/**
 * Grid placement for the 2-up card row.
 *
 * The row is `lg:grid-cols-2`, so an odd number of cards leaves the final tile
 * empty, which reads as a chart that failed to load rather than as a layout.
 * The last card takes both columns instead. A lone card is not spanned: with
 * one card the row is single-column already, and stretching it would make one
 * figure fill the fold.
 */
export function cardSpanClass(index: number, cardCount: number): string {
  const spanLast = cardCount > 1 && cardCount % 2 === 1;
  return spanLast && index === cardCount - 1 ? "lg:col-span-2" : "";
}

/** Two columns only once there is a second card to fill the row.
 *  `items-start` keeps a short plot from stretching to the row or the
 *  viewport: the card sizes to the figure, not the other way round.
 */
export function cardGridClass(cardCount: number): string {
  return `grid grid-cols-1 items-start gap-4 ${cardCount > 1 ? "lg:grid-cols-2" : ""}`;
}
